import React, { useEffect, useState } from "react";
import { Card, Typography as typography_antd } from "antd";
import DOMPurify from "dompurify";
import "./index.css";
import { MenuItem, Select } from "@mui/material";
import EmployeeCompanyPolicyStyle from "./EmployeeCompanyPolicyStyle";
import env from "../../config/env";
import { useDispatch, useSelector } from "react-redux";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;
const { Title } = typography_antd;

function EmployeeCompanyPolicy(props) {
  const token = useSelector((state) => state.auth.token);
  const [companyPolicy, setCompanyPolicy] = useState("");
  const [loading, setLoading] = useState(false);
  const [roleData, setRoleData] = useState();
  const [defaultValue, setDefaultValue] = useState();
  const [selectVal, setSelectVal] = useState();
  const [userDefaultDetails, setUserDefaultDetails] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (props?.role) { getRoleData(); }
  }, [props?.role]);

  const optionList = [];

  const getRoleData = async () => {
    try {

      // Encrypt data
      const encryptedVal = CryptoJS.AES.encrypt((props?.role).toString(), SECRET_KEY).toString();
      const encodedVal = encodeURIComponent(encryptedVal); // ✅ very important

      //Encrypt api endpoint
      const getPolicy = CryptoJS.SHA256("/getPolicy" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(
        `${env.backend_api_endpoint}/${getPolicy}?roleId=${encodedVal}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 400) {
          setLoading(true);

        }
        if (errorData.status === 404) {
          setLoading(true);
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200 && successData.data) {

          // Decrypt backend response
          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          let arr = "";
          let policy_publish = "";
          let policy_status = "";

          decryptedData?.forEach((element) => {
            policy_publish = element.policy_details_publish;
          });
          setCompanyPolicy(policy_publish);
          setLoading(true);

        }
      }
    } catch (error) {
      console.error("Error get Policy in:", error.message);
    }

  };

  function createMarkup(html) {
    return {
      __html: DOMPurify.sanitize(html),
    };
  }

  return (
    <EmployeeCompanyPolicyStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{
            height: "calc(100vh - 75px)",
            // overflowY:"auto",
            padding: "10px"
          }}
          className="card"
          bordered={false}
          style={{
            margin: 10,
          }}
        >
          {loading ? (
            <>
              <div
                className="title_div formControl .custom-Title"
                // style={{ marginBottom: "5px" }}
              >
                {/* <Title
                  level={2}
                  sx={{
                    color: "#244DA0",
                    fontFamily: "ImportedMilliardBold",
                    fontWeignt: 500
                  }}
                >
                  Company Policy
                </Title> */}
                <Title
                  level={2}
                  style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold", fontWeight: 500 }}
                >
                  Company Policy
                </Title>

              </div>
              {(loading &&
                companyPolicy?.length >= 1 &&
                companyPolicy[0] !== undefined) ? (
                <div
                  className="addScroll"
                  style={{
                    maxHeight: "calc(100vh - 150px)",
                    overflowY: "auto",
                    "@media (min-width: 768px)": {
                      // maxHeight: "500px",
                    },

                    "@media (min-width: 1024px)": {
                      // maxHeight: "600px",
                    },
                  }}
                >
                  <div
                    className="preview"
                    dangerouslySetInnerHTML={createMarkup(companyPolicy)}
                    style={{
                      fontFamily: "Milliard",
                      fontSize: "12pt",
                      minHeight: "1024px",
                      "@media (min-width: 768px)": {
                        minHeight: "800px",
                      },
                      "@media (min-width: 1024px)": {
                        minHeight: "1000px",
                      },
                    }}
                  ></div>
                </div>
              ) :
                (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "150px",
                      fontFamily: "ImportedMilliardSemibold",
                    }}
                  >
                    No Data
                  </div>
                )}
            </>
          ) : (
            !loading && <span className="loader"></span>
          )}
        </Card>
      </div>
    </EmployeeCompanyPolicyStyle>
  );
}

export default EmployeeCompanyPolicy;
